import { SurveyQuestion } from './types/survey';

export const SURVEY_ENABLED: boolean = import.meta.env.VITE_SURVEY_ENABLED === 'true';

export const SURVEY_BATCHES: string[] = import.meta.env.VITE_SURVEY_BATCHES ? JSON.parse(import.meta.env.VITE_SURVEY_BATCHES) : [];

export const SURVEY_QUESTIONS: SurveyQuestion[] = [
  {
    id: 'education_level',
    type: 'select',
    question: 'What is your highest level of education completed prior to joining this program?',
    required: true,
    options: [
      { value: '10th', label: '10th Grade' },
      { value: '12th', label: '12th Grade' },
      { value: 'diploma', label: 'Diploma' },
      { value: 'bachelor', label: "Bachelor's Degree" },
      { value: 'master', label: "Master's Degree" },
      { value: 'phd', label: 'PhD/Doctorate' },
      { value: 'other', label: 'Other' }
    ]
  },
  {
    id: 'motivation',
    type: 'multiselect',
    question: 'What motivated you to enroll in this program?',
    required: true,
    options: [
      { value: 'career_advancement', label: 'Career advancement' },
      { value: 'skill_development', label: 'Skill development' },
      { value: 'job_change', label: 'Job change' },
      { value: 'personal_interest', label: 'Personal interest' },
      { value: 'peer_influence', label: 'Peer/family influence' },
      { value: 'other', label: 'Other', hasTextInput: true }
    ]
  },
  {
    id: 'career_goals',
    type: 'select',
    question: 'What are your current career goals?',
    required: true,
    options: [
      { value: 'get_job', label: 'Get a job' },
      { value: 'switch_field', label: 'Switch field' },
      { value: 'promotion', label: 'Promotion' },
      { value: 'start_business', label: 'Start a business' },
      { value: 'higher_education', label: 'Pursue higher education' }
    ]
  },
  {
    id: 'work_experience',
    type: 'conditional',
    question: 'Do you have any prior work experience?',
    required: true,
    options: [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' }
    ],
    conditionalFields: {
      yes: [
        {
          id: 'years_experience',
          type: 'number',
          question: 'Years of experience (0-65)',
          required: true,
          placeholder: 'Enter years (0-65)',
          min: 0,
          max: 65
        },
        { id: 'sector', type: 'text', question: 'Sector/Industry', required: true },
        { id: 'job_title', type: 'text', question: 'Current/Last Job Title', required: true }
      ]
    }
  },
  {
    id: 'employment_status',
    type: 'select',
    question: 'Are you currently employed?',
    required: true,
    options: [
      { value: 'full_time', label: 'Yes, Full-time' },
      { value: 'part_time', label: 'Yes, Part-time' },
      { value: 'no', label: 'No' }
    ]
  },
  {
    id: 'languages',
    type: 'multiselect',
    question: 'Which languages are you fluent in?',
    required: true,
   options : [
  { value: 'english', label: 'English' },
  { value: 'assamese', label: 'Assamese' },
  { value: 'bengali', label: 'Bengali' },
  { value: 'bodo', label: 'Bodo' },
  { value: 'dogri', label: 'Dogri' },
  { value: 'gujarati', label: 'Gujarati' },
  { value: 'hindi', label: 'Hindi' },
  { value: 'kannada', label: 'Kannada' },
  { value: 'kashmiri', label: 'Kashmiri' },
  { value: 'konkani', label: 'Konkani' },
  { value: 'maithili', label: 'Maithili' },
  { value: 'malayalam', label: 'Malayalam' },
  { value: 'manipuri', label: 'Manipuri' },
  { value: 'marathi', label: 'Marathi' },
  { value: 'nepali', label: 'Nepali' },
  { value: 'odia', label: 'Odia' },
  { value: 'punjabi', label: 'Punjabi' },
  { value: 'sanskrit', label: 'Sanskrit' },
  { value: 'santali', label: 'Santali' },
  { value: 'sindhi', label: 'Sindhi' },
  { value: 'tamil', label: 'Tamil' },
  { value: 'telugu', label: 'Telugu' },
  { value: 'urdu', label: 'Urdu' },
  { value: 'other', label: 'Other', hasTextInput: true },
]

  },
  {
    id: 'preferred_language',
    type: 'select',
    question: 'What is your preferred language for learning support or communication?',
    required: true,
    options: [
      { value: 'english', label: 'English' },
      { value: 'hindi', label: 'Hindi' },
      { value: 'kannada', label: 'Kannada' },
      { value: 'other', label: 'Other', hasTextInput: true }
    ]
  },
  {
    id: 'learning_content_preference',
    type: 'multiselect',
    question: 'What type of learning content do you prefer most?',
    required: true,
    options: [
      { value: 'videos', label: 'Videos' },
      { value: 'text', label: 'Text/Reading Materials' },
      { value: 'qna', label: 'Learn by Q&A' },
      { value: 'podcast', label: 'Podcasts' },
      { value: 'lbd', label: 'Learn by doing' },
      { value: 'quizzes', label: 'Interactive Quizzes' },
      { value: 'group_discussions', label: 'Group Discussions' }
    ]
  },
  {
    id: 'digital_comfort',
    type: 'select',
    question: 'How comfortable are you with using digital platforms for learning?',
    required: true,
    options: [
      { value: 'very_comfortable', label: 'Very comfortable' },
      { value: 'somewhat_comfortable', label: 'Somewhat comfortable' },
      { value: 'not_comfortable', label: 'Not comfortable' }
    ]
  },
  {
    id: 'internet_connection',
    type: 'select',
    question: 'What type of internet connection do you usually use for online learning?',
    required: true,
    options: [
      { value: 'broadband', label: 'Broadband' },
      { value: 'mobile_data', label: 'Mobile Data' },
      { value: 'public_wifi', label: 'Public Wi-Fi' },
      { value: 'office_network', label: 'Office network' },
      { value: 'limited_access', label: 'Limited or unreliable access' }
    ]
  },
  {
    id: 'primary_device',
    type: 'multiselect',
    question: 'Which device do you primarily use for online learning?',
    required: true,
    options: [
      { value: 'laptop', label: 'Laptop' },
      { value: 'desktop', label: 'Desktop' },
      { value: 'smartphone', label: 'Smartphone' },
      { value: 'tablet', label: 'Tablet' },
      { value: 'shared_device', label: 'Shared device' }
    ]
  },
  {
    id: 'learning_challenges',
    type: 'conditional',
    question: 'Do you have any specific learning challenges or needs we should be aware of?',
    required: true,
    options: [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' }
    ],
    conditionalFields: {
      yes: [
        {
          id: 'challenges_detail',
          type: 'textarea',
          question: 'Please describe your learning challenges (max 500 characters)',
          required: true,
          maxLength: 500,
          placeholder: 'Describe any learning challenges or special needs...'
        }
      ]
    }
  },
  {
    id: 'study_schedule',
    type: 'select',
    question: 'What is your preferred study schedule?',
    required: true,
    options: [
      { value: 'early_morning', label: 'Early Morning' },
      { value: 'morning', label: 'Morning' },
      { value: 'afternoon', label: 'Afternoon' },
      { value: 'evening', label: 'Evening' },
      { value: 'late_night', label: 'Late Night' },
      { value: 'flexible', label: 'Flexible' }
    ]
  },
  {
    id: 'peer_learning',
    type: 'select',
    question: 'Would you be interested in joining a peer learning group or cohort based on your background?',
    required: true,
    options: [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' },
      { value: 'maybe', label: 'Maybe' }
    ]
  },
  {
    id: 'job_updates',
    type: 'select',
    question: 'Are you open to receiving updates or opportunities related to jobs, internships, and referrals?',
    required: true,
    options: [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' }
    ]
  },
  {
    id: 'referrals',
    type: 'select',
    question: 'Would you be open to referring friends or colleagues who might be interested in similar programs?',
    required: true,
    options: [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' },
      { value: 'maybe', label: 'Maybe' }
    ]
  },
  {
    id: 'social_media',
    type: 'multiselect',
    question: 'Which social media platforms do you actively use?',
    required: true,
    options: [
      { value: 'whatsapp', label: 'WhatsApp' },
      { value: 'facebook', label: 'Facebook' },
      { value: 'instagram', label: 'Instagram' },
      { value: 'linkedin', label: 'LinkedIn' },
      { value: 'telegram', label: 'Telegram' },
      { value: 'twitter', label: 'X (Twitter)' },
      { value: 'other', label: 'Other', hasTextInput: true }
    ]
  },
  {
    id: 'certifications',
    type: 'conditional',
    question: 'Do you have any professional certifications or memberships?',
    required: true,
    options: [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' }
    ],
    conditionalFields: {
      yes: [{ id: 'certifications_detail', type: 'textarea', question: 'Please list your certifications', required: true }]
    }
  },
  {
    id: 'support_areas',
    type: 'multiselect',
    question: 'Would you like support in any of the following areas?',
    required: true,
    options: [
      { value: 'career_planning', label: 'Career planning' },
      { value: 'resume_building', label: 'Resume building' },
      { value: 'language_support', label: 'Language support' },
      { value: 'time_management', label: 'Time management' },
      { value: 'mental_wellness', label: 'Mental wellness' },
      { value: 'tech_support', label: 'Tech support' },
      { value: 'mentoring', label: 'Mentoring' }
    ]
  }
];
